import React from 'react';
import { Info } from 'lucide-react';

/**
 * Les pièces d'une carte de réglages (PARAMETRAGE-MODULES.md §4 et §8) :
 * l'interrupteur, la ligne de réglage et l'encadré d'information.
 *
 * Sorties de la page des alertes critiques (ParametresAlertesCritiques.jsx)
 * le 16/10/2026, balisage inchangé, pour que l'onglet « Données suspectes »
 * (alertesCritiques/DonneesSuspectes.jsx) prenne les mêmes au lieu d'une
 * copie : c'est la recopie qui fait diverger les dimensions de la norme.
 */

/** L'interrupteur de la norme (§4), dimensions figées. */
export const Interrupteur = ({ actif, accent, onBasculer, desactive, enCours, libelle }) => (
  <button
    type="button"
    onClick={onBasculer}
    disabled={desactive || enCours}
    className={`relative h-6 w-11 flex-shrink-0 rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed ${
      enCours ? 'opacity-40' : ''
    }`}
    style={{ backgroundColor: actif ? accent : '#d1d5db', '--tw-ring-color': accent }}
    aria-pressed={actif}
    aria-label={libelle}
  >
    <div
      className={`absolute top-[3px] h-[18px] w-[18px] rounded-full bg-white shadow-sm transition-transform duration-300 ${
        actif ? 'translate-x-[22px]' : 'translate-x-[3px]'
      }`}
    />
  </button>
);

/** Une ligne de réglage : pastille, libellé, description, contrôle à droite. */
export const LigneReglage = ({ actif = true, accent, libelle, description, children }) => (
  <div
    className={`flex flex-wrap items-center justify-between gap-4 px-5 py-4 transition-all ${
      actif ? 'bg-white' : 'bg-gray-50/40'
    } hover:bg-gray-50/70`}
  >
    <div className="flex min-w-[240px] flex-1 items-center gap-3">
      <div
        className="h-1.5 w-1.5 flex-shrink-0 rounded-full"
        style={{ backgroundColor: actif ? accent : '#9ca3af' }}
      />
      <div>
        <p className={`text-sm font-semibold ${actif ? 'text-gray-800' : 'text-gray-400'}`}>{libelle}</p>
        <p className="mt-0.5 max-w-2xl text-[11px] leading-relaxed text-gray-400">{description}</p>
      </div>
    </div>
    <div className="flex flex-shrink-0 items-center gap-3">{children}</div>
  </div>
);

/** L'encadré d'information (§8) : un seul par section. */
export const Encadre = ({ titre, children }) => (
  <div className="rounded-xl border border-[#246990]/20 bg-[#eef7fb] p-4">
    <div className="flex gap-3">
      <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg border border-[#246990]/20 bg-white shadow-sm">
        <Info className="h-4 w-4 text-[#246990]" />
      </div>
      <div className="text-xs leading-relaxed text-gray-600">
        <p className="mb-1 text-[13px] font-semibold text-[#246990]">{titre}</p>
        {children}
      </div>
    </div>
  </div>
);
